export default (number) => number % 2 === 0
